import { AppBar, Box, Tab, Tabs } from "@mui/material";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { JumboDrawer } from "./JumboDrawer";
import SpotItemCreatePanel from "./SpotItemCreatePanel";
import SpotCreateByPlaceSearch from "./SpotCreateByPlaceSearch";
import SpotItemDetailPanel from "./SpotItemDetailPanel";
import { SpotItemPageDraftTab } from "./SpotItemPageDraftTab";
import { SpotITemPagePublicTab } from "./SpotItemPagePublicTab";
import Template from "./Template";
import { useState } from "react";
import { callbackDraftPathAtom, callbackPublicPathAtom, callbackTabAtom } from "../atom";
import { useAtom } from "jotai/react";

const SpotItemPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { spotId } = useParams();

  const isCreateByMapPage = location.pathname === "/spots/create";
  const isCreateByUrlPage = location.pathname === "/spots/create/url";
  const isPublicPage = location.pathname.split("/").slice(-1).includes("public");
  const isDraftPage = location.pathname.split("/").slice(-1).includes("spots");

  const [isEditing, setIsEditing] = useState(false);

  const [callbackDraftPath] = useAtom(callbackDraftPathAtom);
  const [callbackPublicPath] = useAtom(callbackPublicPathAtom);
  const [callbackTab] = useAtom(callbackTabAtom);

  // Jotaiからスポット詳細を閉じる際の戻り先を決定
  const handleSpotDetailClose = () => {
    if (callbackTab === "draft") {
      navigate(`/spots${callbackDraftPath}`);
      return;
    }
    if (callbackTab === "public") {
      navigate(`/spots/public${callbackPublicPath}`);
      return;
    }
    // フォールバック: タブ情報がない場合は現在のパスに基づく
    navigate("/spots");
  };

  return (
    <>
      <Template title="スポット管理">
        <AppBar component="div" position="static" elevation={0} sx={{ zIndex: 0 }}>
          <Tabs
            value={isDraftPage ? "draft" : isPublicPage ? "public" : ""}
            textColor="inherit"
            aria-label="spot item page tabs"
          >
            <Tab label="下書き" onClick={() => navigate("/spots")} value="draft" />
            <Tab label="公開済" onClick={() => navigate("/spots/public")} value="public" />
          </Tabs>
        </AppBar>
        <Box component="main" sx={{ flex: 1, px: 2, bgcolor: "#eaeff1" }}>
          {isDraftPage && <SpotItemPageDraftTab />}
          {isPublicPage && <SpotITemPagePublicTab />}
        </Box>
      </Template>
      <JumboDrawer open={isCreateByMapPage} anchor="right" onClose={() => navigate("/spots")}>
        <SpotCreateByPlaceSearch />
      </JumboDrawer>
      <JumboDrawer open={isCreateByUrlPage} anchor="right" onClose={() => navigate("/spots")}>
        <Box p={2}>
          <SpotItemCreatePanel />
        </Box>
      </JumboDrawer>
      <JumboDrawer open={spotId !== undefined} anchor="right" onClose={handleSpotDetailClose}>
        <Box>
          <SpotItemDetailPanel isEditing={isEditing} setIsEditing={setIsEditing} />
        </Box>
      </JumboDrawer>
    </>
  );
};

export default SpotItemPage;
